import { useState } from "react";
import { Mail } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ORG_CHART, TEAM } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export default function OrgChart() {
  const [active, setActive] = useState(null);
  const { t } = useLang();

  const tr = (m) => t.team[m.name] || { role: m.role, bio: m.bio };

  return (
    <div>
      <p className="text-sm font-medium text-[#16A34A] mb-4">{t.about.teamHint}</p>

      <div className="relative w-full rounded-2xl overflow-hidden shadow-xl border border-[#E2E8F0] bg-[#3a4459]" data-testid="org-chart">
        <img src={ORG_CHART} alt="Cornerstone FOCCUS Food Pantry organizational chart — Meet Our Team" className="w-full h-auto block select-none" />

        {TEAM.map((m, i) => (
          <button
            key={m.name}
            type="button"
            onClick={() => setActive(m)}
            aria-label={`${tr(m).role} — ${m.name}`}
            data-testid={`team-hotspot-${i}`}
            className="hotspot-pulse absolute -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-transparent hover:border-white hover:ring-4 hover:ring-[#E85D04]/60 focus-visible:border-white transition-all cursor-pointer"
            style={{
              left: `${m.hotspot.left}%`,
              top: `${m.hotspot.top}%`,
              width: `${m.hotspot.size || 8}%`,
              aspectRatio: "1 / 1",
              animationDelay: `${(i % 5) * 0.3}s`,
            }}
          />
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="sm:max-w-md" data-testid="team-bio-dialog">
          {active && (
            <>
              <DialogHeader>
                <div className="w-14 h-14 rounded-full bg-[#16A34A]/10 flex items-center justify-center mb-3">
                  <span className="font-display font-extrabold text-lg text-[#16A34A]">
                    {active.name.split(" ").map((x) => x[0]).slice(0, 2).join("")}
                  </span>
                </div>
                <DialogTitle className="font-display text-2xl text-[#0A2540]">{active.name}</DialogTitle>
                <DialogDescription className="text-sm font-semibold text-[#16A34A]">{tr(active).role}</DialogDescription>
              </DialogHeader>
              <p className="text-[#475569] leading-relaxed">{tr(active).bio}</p>
              {active.email && (
                <a href={`mailto:${active.email}`} data-testid="team-bio-email" className="inline-flex items-center gap-2 mt-4 text-sm font-semibold text-[#E85D04] hover:text-[#CC5202] break-all">
                  <Mail className="w-4 h-4 shrink-0" aria-hidden="true" /> {active.email}
                </a>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
